import $ from 'jquery';

export default class {
	constructor(options) {
		const defaults = {
			el: '#showcaseGroups',
			dom: {
				thumb: '.js-showcase-thumb'
			},
			classes: {
				count: 'b-showcase-groups_items_count-',
				thumb: {
					state: {
						active: 'b-showcase-groups__thumb_state_active'
					}
				}
			},
			callback: {
				set: false,
				check: false
			},
			data: []
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		return this;
	}

	getDom() {
		this.$thumb = this.$el.find(this.options.dom.thumb);
		return this;
	}

	build() {
		this.$el.addClass(this.options.classes.count + this.$thumb.length);
		this.$thumb = this.$el.find(this.options.dom.thumb);
		return this;
	}

	onClick(event) {
		let change = true;
		if (typeof this.options.callback.check == 'function') {
			change = this.options.callback.check();
		}
		if (change) {
			const $target = $(event.currentTarget);
			const {index, ancor} = $target.data();
			this.$thumb.not($target).removeClass(this.options.classes.thumb.state.active);
			$target.addClass(this.options.classes.thumb.state.active);
			if (typeof this.options.callback.set == 'function') {
				this.options.callback.set(index, ancor);
			}
		}
	}

	setAncor(ancor) {
		const $target = this.$thumb.filter('[data-ancor="' + ancor + '"]');
		let index = -1;
		if ($target.length) {
			if (!$target.hasClass(this.options.classes.thumb.state.active)) {
				this.$thumb.not($target).removeClass(this.options.classes.thumb.state.active);
				$target.addClass(this.options.classes.thumb.state.active);
			}
			index = $target.data('index');
		}
		return index;
	}

	getActive() {
		const $active = this.$thumb.filter('.' + this.options.classes.thumb.state.active);
		if (!$active.length) {
			return false;
		}
		const {index, ancor} = $active.data();
		return {index, ancor};
	}

	setActive(index) {
		this.$thumb.eq(index).addClass(this.options.classes.thumb.state.active);
		return this;
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.build();
			this.$el.on('click', this.options.dom.thumb, this.onClick.bind(this));
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/showcase/groups/groups.js